import { NonOptional } from '@insight-health-ai/roseate/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Tag } from 'src/models';
import { api } from 'src/services/api';
import { useGetTagList } from './useGetTagList';
import { groupBy } from 'lodash';

type UpdateTagDetailsPayload = NonOptional<Partial<Tag>, 'id'>;

export const useUpdateTagDetails = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['updateTagDetails'],
    mutationFn: ({ id, ...payload }: UpdateTagDetailsPayload) =>
      api.put(`/v3/tag/${id}`, payload),
    onSuccess: (_, payload) => {
      queryClient.setQueriesData<ReturnType<typeof useGetTagList>['data']>(
        { queryKey: ['tagList'] },
        (oldData) => {
          if (!oldData) return oldData;

          const newTags = oldData.tags.map((tag) => {
            if (tag.id !== payload.id) return tag;
            return {
              ...tag,
              ...payload,
            };
          });

          return {
            ...oldData,
            tags: newTags,
            groupedTags: groupBy(newTags, 'category'),
          };
        }
      );
    },
  });
};
